import { render } from "./GraficoIPC.vue?vue&type=template&id=721b4c76&scoped=true"
import script from "./GraficoIPC.vue?vue&type=script&lang=js"
export * from "./GraficoIPC.vue?vue&type=script&lang=js"

import "./GraficoIPC.vue?vue&type=style&index=0&id=721b4c76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721b4c76"]])

export default __exports__